import Vue from 'vue'
import App from './App.vue'
import Index from './components/Index.vue'
import router from './Services/Router/Router'
import store from "./store";
import Http from './Services/HttpService/HttpService'

// Partials
import i18n from './Partials/Lang/lang';

//packages
import axios from 'axios';
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueProgressBar from 'vue-progressbar'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import InfiniteLoading from 'vue-infinite-loading';
import VueHtmlToPaper from 'vue-html-to-paper';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import tinymce from 'vue-tinymce-editor';
import vSelect from 'vue-select'
import JsonExcel from "vue-json-excel";
import VueClipboard from 'vue-clipboard2'
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


// Progress Bar
const options = {
    color: '#2fb72f',
    failedColor: '#f4061a',
    thickness: '8px',
    transition: {
        speed: '0.9s',
        opacity: '0.4s',
        termination: 600
    },
    autoRevert: true,
    location: 'top',
    inverse: false
};

// Print Options
const optionsPrint = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
        'https://unpkg.com/kidlat-css/css/kidlat.css'
    ]
};

// **************************** use functions *****************************

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
//Progress Bar
Vue.use(VueProgressBar, options);
//infinite scroll
Vue.use(InfiniteLoading);
//Print Plugin
Vue.use(VueHtmlToPaper, optionsPrint);
// datepicker
Vue.component('date-picker', VuePersianDatetimePicker);
// Editor
Vue.component('tinymce', tinymce);
// select
Vue.component('v-select', vSelect);
// count down
Vue.component(VueCountdown.name, VueCountdown);
// json excel
Vue.component("downloadExcel", JsonExcel);
// copy to clipboard
Vue.use(VueClipboard);
// number format
Vue.filter('numFormat', numFormat(numeral));


Vue.config.productionTip = false;
const token = localStorage.getItem('tokenAdmin');

if (token) {
    axios.interceptors.request.use(
        (config) => {
            if (token) {
                config.headers['Authorization'] = `Bearer ${ token }`;
            }

            return config;
        },

        (error) => {
            return Promise.reject(error);
        }
    );
    //axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}
axios.interceptors.response.use((response) => {

    return response;

}, (error) => {
    if (error.response && error.response.data) {
        //add your code
        if (error.response.status === 401 || error.response.status === 400) {
            //add your code
            localStorage.removeItem('tokenAdmin');
            localStorage.removeItem('role');
            delete axios.defaults.headers.common['Authorization'];
            window.location = Http.addressImage();
        }
        return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
});

Vue.config.productionTip = false;
Vue.config.devtools = true; // Enable Vue DevTools in production for debugging

new Vue({
    store,
    router,
    i18n,
  render: h => h(Index),
}).$mount('#app');

